const NAME = "MY_PENDING_PAGE";

export default NAME;
